module.exports = __webpack_public_path__ + "f797ef0442462b9685f64506431a37de.png";